import { render, staticRenderFns } from "./AdminDashBoard.vue?vue&type=template&id=47aff68c&scoped=true&"
import script from "./AdminDashBoard.vue?vue&type=script&lang=js&"
export * from "./AdminDashBoard.vue?vue&type=script&lang=js&"
import style0 from "./AdminDashBoard.vue?vue&type=style&index=0&id=47aff68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aff68c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAvatar,VCard,VCol,VDivider,VImg,VRow,VSimpleTable,VToolbar,VToolbarTitle})
